import React, { useEffect } from "react";
import { useContext } from "react";
import ModalContext from "../../../context/ModalContext";

export interface IModalEventHandlerProps {
    children?: React.ReactElement;
}

export default (props: IModalEventHandlerProps) => {
    const { openModal, closeModals } = useContext(ModalContext);

    useEffect(() => {
        function modalEventHandler(event: MouseEvent) {
            const target = event.target as HTMLElement;
            const modalId = target.dataset.modalId;
            // const modalId = target.getAttribute('data-modal-id');
            if (modalId) {
                event.preventDefault();
                openModal(modalId );
            }
            if (target.classList.contains('close-modal')) {
                closeModals();
            }
        }
        document.addEventListener('click', modalEventHandler);
        return () => {
            document.removeEventListener('click', modalEventHandler);
        }
    }, []);

    return (
        <>
            {props.children}
        </>
    );
};
